import styled from '@emotion/styled';
import { withConfig } from 'src/withConfig';

export const RaceOverviewDataItem = withConfig(theme => styled('span', { label: 'RaceOverviewDataItem' })`
    position: relative;
    &::before {
        content: '•';
        margin: 0 4px;
    }
    @media ${theme.star.mediaQuery.tablet} {
        &::before {
            content: none;
        }
        &::after {
            content: '•';
            margin: 0 4px;
        }
        &:last-of-type {
            &::after {
                content: none;
            }
        }
    }
`);

export const RaceOverviewDetails = withConfig(theme => styled('span', { label: 'RaceOverviewDetails' })`
    color: ${theme.star.raceSummary.txtColorSecondary};
    pointer-events: none;
    @media ${theme.star.mediaQuery.tablet} {
        color: ${theme.star.raceSummary.txtColor};
    }
`);

export const RaceOverviewData = withConfig(theme => styled('div', { label: 'RaceOverviewData' })`
    color: ${theme.star.raceSummary.txtColorSecondary};
    font-size: ${theme.star.fontSize.xSmall};
    line-height: 1.4;
    @media ${theme.star.mediaQuery.tablet} {
        color: ${theme.star.raceSummary.txtColor};
        display: flex;
        flex-flow: column nowrap;
        flex: 0 0 50%;
        gap: 2px;
    }
`);
